import { tryParseJson } from '@/lib/utils'
import type { ChainRunLink, TriggerInputField } from '@/types'

export type ChainLinkInputSource =
  | { kind: 'mapping'; expression: string }
  | { kind: 'supplied' }
  | { kind: 'missing' }
  | { kind: 'default' }

function isMappingExpression(value: string): boolean {
  return value.includes('${{')
}

export function describeInputSource(link: ChainRunLink, name: string): ChainLinkInputSource {
  const mapping = link.inputMappings?.[name]
  if (mapping !== undefined) return { kind: 'mapping', expression: mapping }
  if (link.suppliedInputs?.[name] !== undefined) return { kind: 'supplied' }
  if (link.missingInputs?.includes(name)) return { kind: 'missing' }
  return { kind: 'default' }
}

export function formatInputValue(value: unknown): string | null {
  if (value == null) return null
  if (Array.isArray(value)) return `${value.length} selected`

  if (typeof value === 'string') {
    if (value.trim() === '') return null
    const parsed = tryParseJson(value)
    if (Array.isArray(parsed)) return `${parsed.length} selected`
    return value
  }

  if (typeof value === 'object') return JSON.stringify(value)
  return String(value)
}

export function resolveInputDisplayValue(link: ChainRunLink, field: TriggerInputField): string {
  if (link.run) {
    return formatInputValue(link.run.inputValues?.[field.name]) ?? '—'
  }

  const supplied = link.suppliedInputs?.[field.name]
  if (supplied !== undefined) return formatInputValue(supplied) ?? '—'

  const mapping = link.inputMappings?.[field.name]
  if (mapping !== undefined && !isMappingExpression(mapping)) {
    return formatInputValue(mapping) ?? '—'
  }

  return formatInputValue(field.default) ?? '—'
}
